/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RequestSyncCardTransactionsToFreeeForAccountingRequest
 */
export interface RequestSyncCardTransactionsToFreeeForAccountingRequest {
    /**
     * nullを指定した場合はFROM_TARGET_DATEがデフォルト
     * @type {string}
     * @memberof RequestSyncCardTransactionsToFreeeForAccountingRequest
     */
    'syncMode': RequestSyncCardTransactionsToFreeeForAccountingRequestSyncModeEnum;
}

export const RequestSyncCardTransactionsToFreeeForAccountingRequestSyncModeEnum = {
    targetDate: 'FROM_TARGET_DATE',
    latestSyncId: 'FROM_LATEST_SYNC_ID'
} as const;

export type RequestSyncCardTransactionsToFreeeForAccountingRequestSyncModeEnum = typeof RequestSyncCardTransactionsToFreeeForAccountingRequestSyncModeEnum[keyof typeof RequestSyncCardTransactionsToFreeeForAccountingRequestSyncModeEnum];


